import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-textarea',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    template: `
        <div [formGroup]="form" [id]="field.key" [class]="'form-group schema-form-textarea has-feedback ' + props['htmlClass']"
        [class.has-success]="(formControl.touched || formControl.dirty) && formControl.status === 'VALID'"
        [class.has-error]="(formControl.touched || formControl.dirty) && formControl.status === 'INVALID'">
            <label *ngIf="props['title']"
              [class]="'control-label ' + props['labelHtmlClass'] || ''"
              [innerHTML]="props.required !== true ? props['title'] + ' (Optional)' : props['title']">
            </label>
            <p *ngIf="props['supportingText']">{{props['supportingText']}}</p>
            <div class="has-feedback">
                <textarea
                    [formControl]="formControl"
                    [formlyAttributes]="field"
                    [attr.required]="props.required"
                    [attr.aria-describedby]="'control' + field.key + 'Status'"
                    [attr.list]="'control' + field.key + 'Autocomplete'"
                    [class]="'form-control ' + props['fieldHtmlClass'] || ''"
                    [id]="'control' + field.key"
                    [name]="field.key"
                    [attr.disabled]="props.disabled"
                    [attr.maxlength]="props.maxLength || 2000"
                    [attr.minlength]="props.minLength || 0"
                >
                </textarea>
                <i *ngIf="(formControl.dirty || formControl.touched)" class="fa form-control-feedback" [class.fa-times-circle-o]="formControl.status === 'INVALID'" [class.fa-check-circle-o]="formControl.status === 'VALID'"></i>
            </div>
            <span class="help-block" *ngIf="(formControl.dirty || formControl.touched)">
                <formly-validation-message [field]="field"></formly-validation-message>
            </span>
        </div>
    `
})
export class TextAreaFieldTypeComponent extends FieldType<FieldTypeConfig> { }
